import DocumentCategoryService from 'src/modules/documentCategory/documentCategoryService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import {getHistory} from 'src/modules/history';
import {i18n} from 'src/i18n';

const prefix = 'DOCUMENT_CATEGORY_FORM';

const documentCategoryFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: documentCategoryFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await DocumentCategoryService.find(id);
      }

      dispatch({
        type: documentCategoryFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: documentCategoryFormActions.INIT_ERROR,
      });

      getHistory().push('/document-category');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: documentCategoryFormActions.CREATE_STARTED,
      });

      await DocumentCategoryService.create(values);

      dispatch({
        type: documentCategoryFormActions.CREATE_SUCCESS,
      });

      Message.success(i18n('entities.documentCategory.create.success'));

      getHistory().push('/document-category');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: documentCategoryFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: documentCategoryFormActions.UPDATE_STARTED,
      });

      await DocumentCategoryService.update(id, values);

      dispatch({
        type: documentCategoryFormActions.UPDATE_SUCCESS,
      });

      Message.success(i18n('entities.documentCategory.update.success'));

      getHistory().push('/document-category');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: documentCategoryFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default documentCategoryFormActions;
